import { ErrorMessage } from 'formik'

export function FormikError(props: any): JSX.Element {
    const { name, errors, touched } = props
	
    return touched[name] && errors[name] && <ErrorMessage name={name} component="div" className="input-error-message" />
}
